/**
 * 计算注数完成后的算法，应该使用在此文件规则中STOP
 * 优先级最低，权重区间 10000 - 0 步长100
 */
import { formatPrizeDisplay } from '../../../helpers/unit'

export default function Ending(R){
	return [
		{
			// SSC最终合并，形成输出对象
			priority: 100,
			condition: function(R) {
				R.when( this.lotteryType === 'ssc' );
			},
			consequence: function(R) {
				// 投注提交所需对象
				let forBet = {};
				let betCodes = [];
				forBet.methodid = this.currentMethod.methodid;
				// 如果是单行的话，那么直接以&相连
				if (_.includes(['input', 'box'], this.currentMethod.selectarea.type)) {
					forBet.codes = _.join(this.formatCodes.map((item) => _.join(item, this.sortSplit || '')), '&');
				}else{
					forBet.codes = _.join(this.formatCodes.map((item) => _.join(item, '&')), '|');
				}
				forBet.omodel = Number(this.prize) || 1;
				forBet.mode = this.mode.modeid;
				forBet.times = this.times;
				forBet.poschoose = this.poschoose || null;
				forBet.menuid = this.currentMethod.menuid;
				forBet.type = this.currentMethod.selectarea.originType || this.currentMethod.selectarea.type;
				forBet.nums = this.num;
				forBet.money = this.money;
				forBet.solo = this.solo || false;
				// 客户端显示所需对象
				betCodes = [];
				_.forEach(this.formatCodes, function(item){
					// 数组的话，那么相连
					if ( _.isArray(item) && this.currentMethod.show_str != 'X') {
						betCodes.push(item.toString().replace(/,/g, this.currentMethod.code_sp));
					}
					// 如果是字符串的话，那么直接添加
					if ( _.isString(item) || this.currentMethod.show_str === 'X') {
						betCodes.push(item);
					}
				}.bind(this))
				let forDisplay = {};
				forDisplay.prize = this.prize ? '模式:' + formatPrizeDisplay(_.find(this.currentMethod.prize, {value: Number(this.prize)}).label) : '';
				forDisplay.mode = this.mode.name;
				forDisplay.rate = this.mode.rate;
				forDisplay.times = this.times + '倍';
				forDisplay.money = this.money;
				forDisplay.num = this.num ;
				forDisplay.methodName = '[' + this.currentCategory.name + '_' + this.currentMethod.desc + ']';
				forDisplay.codes = [];
				forDisplay.prize_group = this.currentMethod.prize;
				forDisplay.prize_level = this.currentMethod.level;
				forDisplay.solo = this.solo || false;
				forDisplay.currentPrize = this.currentPrize;
				forDisplay.currentBonus = this.currentBonus;
				if (_.includes(['input', 'box'], this.currentMethod.selectarea.type)) {
					// 如果单式，那么直接数组相连
					forDisplay.codes = _.join(betCodes.map((item) => _.join(item, this.sortSplit || '')), this.currentMethod.code_sp);
				}else{
					// 如果不是，则将show_str 和数组进行对应
					let codeIndex = 0;
					_.forEach(_.split(this.currentMethod.show_str, ','), function(item, index){
						if (item === 'X') {
							forDisplay.codes[index] = betCodes[codeIndex] || '-';
							codeIndex ++;
						}else{
							forDisplay.codes[index] = item;
						}
					})
					const code_sp = (!this.currentMethod.code_sp || this.currentMethod.code_sp == " ") ? ',' : this.currentMethod.code_sp
					forDisplay.codes = this.displayCodes || _.join(forDisplay.codes, code_sp);
				}
				// 添加一个描述到提交对象里面
				forBet.desc = forDisplay.methodName + forDisplay.codes;
				// 封装合并值
				this.done = {
					display: forDisplay,
					submit: forBet,
					message: this.message
				}
			R.stop();
			}
		},
		{
			// 通用六合彩处理规则
			priority: 100,
			condition: function(R) {
					R.when( _.includes(this.ruleSuite, 'lhc-common') );
			},
			consequence: function(R) {
				let forDisplay = [];
				let forSubmit = [];
				_.forEach(this.bet.codes, function(code, index){
					// 如果有填入金额
					if (code.value && Number(code.value) > 0) {
						let _display = {};
						let _submit = {};
						// 显示相关
						_display.methodName = '[' + this.currentMethod.data_label[0].label[0].gtitle + '_' + code.name + ']';
						_display.codes = code.num;
						_display.times = code.value + '倍';
						_display.num = 1;
						_display.money = Number(code.value);
						_display.mode = '元';
						_display.prize = this.bet.prize ? '模式:' + formatPrizeDisplay(_.find(this.currentMethod.prize, {value: Number(this.bet.prize)}).label) : '';
						// 提交相关
						_submit.omodel = this.bet.prize;
						_submit.mode = 1;
						_submit.times = code.value;
						_submit.methodid = code.methodid;
						_submit.codes = code.num;
						_submit.menuid = code.menuid;
						_submit.type = code.type;
						_submit.money = Number(code.value);
						_submit.nums = 1;
						_submit.desc = _display.methodName + _display.codes;
						// 添加
						forDisplay.push(_display);
						forSubmit.push(_submit)
					}
				}.bind(this))
				// 返回
				this.done = {
					currentPrize: this.currentPrize,
					currentBonus: this.currentBonus,
					display: forDisplay,
					submit: forSubmit,
					message: this.message
				}

				R.stop();
			}
		}
	]
}